import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { PlanITQueryKeys } from "components/PlanIT/queryKeys";
import { ApiInstance } from "utils/Api";

import type { PlanITDocumentationInfoType } from "components/PlanIT/queryKeys";

export const usePlanITAppointmentData = ({ appointment_id }: { appointment_id: number }) => {
  const { baseUrl, endpoint } = PlanITQueryKeys.data;

  const [data, setData] = useState<PlanITDocumentationInfoType | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlanITData = async () => {
      try {
        setError(null);
        setIsLoading(true);
        const response = await ApiInstance.post(endpoint, { appointment_id }, baseUrl); // TODO: rewrite with useTypedQuery
        setData(response.data);
      } catch (error) {
        if (error instanceof Error) setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlanITData();
  }, []);

  useEffect(() => {
    if (error && !isLoading) toast.error(error);
  }, [error, isLoading]);

  return { data, isLoading };
};
